// extracted by mini-css-extract-plugin
export default {"oversizedLiItem":"styles__oversizedLiItem___3yEQF"};